import { useEffect, useState } from 'react';
import * as Popover from '@radix-ui/react-popover';
import { MoreHorizontal } from 'lucide-react';
import { CONTENT_EDITOR_HOST_LOAD_META } from './useContentEditorKernel.js';

export function ContentEditorToolbarOverflow({ compact, editor, profile, children }) {
  const [open, setOpen] = useState(false);
  useEffect(() => { setOpen(false); }, [editor, profile]);
  useEffect(() => {
    if (!editor) return;
    const closeOnLoad = ({ transaction }) => { if (transaction.getMeta(CONTENT_EDITOR_HOST_LOAD_META)) setOpen(false); };
    editor.on('transaction', closeOnLoad);
    return () => editor.off('transaction', closeOnLoad);
  }, [editor]);
  if (!compact) return children;
  return <Popover.Root open={open} onOpenChange={setOpen}><Popover.Trigger asChild><button type="button" aria-label="More editor controls" title="More editor controls" onMouseDown={event => event.preventDefault()}><MoreHorizontal size={18} aria-hidden="true"/></button></Popover.Trigger><Popover.Portal><Popover.Content aria-label="More editor controls" className="mts-editor-toolbar mts-editor-toolbar-overflow" sideOffset={6} align="end">{children}</Popover.Content></Popover.Portal></Popover.Root>;
}
